export enum appStateEnums {
  THEME = 'theme',
  COLLAPSE = 'collapse',
  HIDE_IMPORTANT_NOTIFICATIONS = 'hideImportantNotifications',
  INIT_STATES = 'INIT_STATES',
  LP_DATA = 'LP_DATA'
}
